// Imágenes de portada del producto (build de PRODUCCIÓN: CDN de Unsplash).
// Se aíslan aquí para que el build DEMO pueda sustituirlas por copias auto-hospedadas
// (requisito del PO: cero peticiones externas en la demostración).
export const HERO_LOGIN =
  "https://images.unsplash.com/photo-1724906019868-93ad2c79414f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";

export const HERO_LANDING =
  "https://images.unsplash.com/photo-1724906019868-93ad2c79414f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";
